import React from "react";
import TempleTimingsInfo from "./TempleTimingsInfo";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Timing() {
    const { t } = useTranslation();
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/temple.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>

            <div className="container" style={{ backgroundImage: 'url(./images/thali-.jpeg)', padding: '0px', backgroundSize: 'cover', backgroundAttachment: 'fixed', borderRadius: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* <TempleTimingsInfo /> */}



                <div class="container" style={{ margin: '0px', width: '60%' }}>
                    {/* <div class="header-">പൂജാ സമയം</div> */}
                    {/* <!-- Subrahmanya Temple --> */}
                    <div class="card-1">
                        <center><img src="/images/siva.png" alt="Sivan" className="murugan-img" style={{width:'30%'}} /></center>
                        <h2 style={{ fontFamily: 'manjari', fontSize: '22pt', fontWeight: '600' }}>Temple Timings </h2>

                        {/* <div class="section-title">{t("mor")} </div> */}
                        <div class="time-row"><span>Morning </span><span>05:00 AM to 10:30 AM</span></div>
                        


                        {/* <div class="section-title">{t("even")} </div> */}
                        <div class="time-row"><span>Evening</span><span>05:15 PM to 07:30 PM</span></div>
                        


                        {/* <div class="highlight">
                            <u>Please note:</u>
                            <br />
                          Timing changes during festivals, Udayasthamana puja days
                        </div> */}
                    </div>

                    {/* <!-- Ayyappa Temple --> */}
                    {/* <div class="card-1">
                        <h2 style={{ fontFamily: 'manjari' }}>{t("ayyapat")} </h2>

                        <div class="section-title">{t("mor")} </div>
                        <div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
                        <div class="time-row"><span>{t("abkk")} </span><span>04:45 - 05:15</span></div>
                        <div class="time-row"><span>{t("ushpoo")} </span><span>06:00 - 06:30</span></div>
                        <div class="time-row"><span>{t("uchpoo")} </span><span>10:00 - 11:30</span></div>
                        <div class="time-row"><span>{t("nadad")} </span><span>12:30</span></div>

                        <div class="section-title">{t("even")} </div>
                        <div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
                        <div class="time-row"><span>{t("dheebef")} </span><span>07:00 - 07:30</span></div>
                        <div class="time-row"><span>{t("nadad")} </span><span>07:30</span></div>

                    </div> */}

                </div>


            </div>
        </div>
    );
}

export default Timing;